import React from 'react';
import MenuItem from '@mui/material/MenuItem';
import FormControl from '@mui/material/FormControl';
import Select from '@mui/material/Select';

const SelectSpec = ({
  name,
  customArray,
  placeTitle,
  index,
  selectedValue,
  onChange,
  disablek,
}) => {
  // 1. District Selection Logic
  if (name === 'ilce') {
    const handleChange = (event) => {
      const value = event.target.value;
      onChange(value);
    };

    return (
      <div className="select animated zoomIn mb-4">
        <FormControl fullWidth disabled={disablek}>
          <Select
            className="custom-selector custom-select"
            labelId="demo-simple-select-label"
            id="demo-simple-select"
            value={selectedValue}
            onChange={handleChange}
          >
            {/* Using optional chaining to prevent crash if customArray is empty */}
            {customArray && customArray.length > 0 && customArray.map((option, idx) => (
               <MenuItem
                key={option.value || idx}
                className="custom-menu option"
                value={option.value} 
              >
                {option.value} 
              </MenuItem>
            ))}
          </Select>
        </FormControl>
      </div>
    );
  } else {
    // 2. City or Point Type Selection Logic
    const handleChange = (event) => {
      const value = event.target.value;
      onChange(value);
    };

    return (
      <div className="select animated zoomIn mb-4">
        <FormControl fullWidth>
          <Select
            className="custom-selector custom-select"
            labelId="demo-simple-select-label"
            id="demo-simple-select"
            value={selectedValue}
            onChange={handleChange}
          >
            {customArray.map((option, index) => (
              <MenuItem
                key={option.id || index}
                className="custom-menu option"
                value={option.name}
              >
                {/* Updated Label Logic for new Emanet type */}
                {option.name === 'Box' ? 'EASY POINT TESLIMAT DOLABI' :
                 option.name === 'EasyPoint' ? 'EASY POINT DESK' :
                 option.name === 'Esnaf' ? 'EASY POINT ESNAF' :
                 option.name === 'Emanet' ? 'EASY POINT EMANET DOLABI' :
                 option.name?.toUpperCase()}
              </MenuItem>
            ))}
          </Select>
        </FormControl>
      </div>
    );
  }
};

export default SelectSpec;